import React from 'react';
import Alert from 'react-bootstrap/Alert';
import { DataSource } from '../../../enums/DataSource';
import { RecipeTable } from '../../../enums/RecipeTable';
import { strings } from '../../../resources/strings';
import { Recipe } from '../../../models/Recipe';
import { CardRecipeV2 } from '../CardRecipeV2/CardRecipeV2';
import { CardCustomerRecipe } from '../CardCustomerRecipe/CardCustomerRecipe';
import { LinkedCustomerRecipe } from '../../../models/LinkedCustomerRecipe';
import { ProductRecipeLinkingRequest } from '../../../models/ProductRecipeLinkingRequest';
import { CardLinksRecipeByProduct } from '../CardLinksRecipeByProduct/CardLinksRecipeByProduct';

interface ITabRecipeLinkingProps {
  recipes?: Recipe[];
  linkedCustomerRecipes?: LinkedCustomerRecipe[];
  orderDataSource?: DataSource;
  readonly?: boolean;
  editRecipe?: (recipeId: number, recipeTable: RecipeTable) => void;
  deleteRecipe?: (recipeId: number, recipeTable: RecipeTable) => void;
  deleteLinking?: (linking: ProductRecipeLinkingRequest) => void;
}

const TabRecipeLinking: React.FC<ITabRecipeLinkingProps> = ({
  recipes,
  linkedCustomerRecipes,
  orderDataSource,
  readonly,
  editRecipe,
  deleteRecipe,
  deleteLinking
}) => {

  const recipeCards = React.useMemo(() => {
    const numberOfRecipes = (recipes?.length || 0) + (linkedCustomerRecipes?.length || 0);

    return recipes?.map(recipe => {
      return <CardRecipeV2
              key={`recipe-${recipe.id}`}
              recipe={recipe}
              editRecipe={editRecipe ? (() => editRecipe(recipe.id, RecipeTable.Recipe)) : undefined}
              deleteRecipe={deleteRecipe ? (() => deleteRecipe(recipe.id, RecipeTable.Recipe)) : undefined}
              orderDataSource={orderDataSource}
              readonly={readonly}
              showExpanded={numberOfRecipes === 1}
            />;
    }) || [];
  }, [recipes, orderDataSource, readonly, linkedCustomerRecipes]);

  const linkingRequestCards = React.useMemo(() => {
    const numberOfRecipes = (recipes?.length || 0) + (linkedCustomerRecipes?.length || 0);

    return linkedCustomerRecipes?.map(linkedCustomerRecipe => {
      return <CardLinksRecipeByProduct
                linkingRequests={linkedCustomerRecipe.linkingRequests}
                key={`link-customer-recipe-${linkedCustomerRecipe.customerRecipe.id}`}
                deleteLinking={deleteLinking ? (linking) => deleteLinking(linking) : undefined}
              >
                <CardCustomerRecipe
                  key={`customer-recipe-${linkedCustomerRecipe.customerRecipe.id}`}
                  recipe={linkedCustomerRecipe.customerRecipe}
                  linked={linkedCustomerRecipe.linkingRequests.length > 0}
                  editRecipe={editRecipe ? (() => editRecipe(linkedCustomerRecipe.customerRecipe.id, RecipeTable.CustomerRecipe)) : undefined}
                  deleteRecipe={deleteRecipe ? (() => deleteRecipe(linkedCustomerRecipe.customerRecipe.id, RecipeTable.CustomerRecipe)) : undefined}
                  orderDataSource={orderDataSource}
                  readonly={readonly}
                  showExpanded={numberOfRecipes === 1}
                />
            </CardLinksRecipeByProduct>
    }) || [];
  }, [recipes, orderDataSource, readonly, linkedCustomerRecipes]);

  const body = React.useMemo(() => {
    const numberOfRecipes = (recipeCards?.length||0) + (linkingRequestCards?.length||0);
    const orderHasAnyRecipe = numberOfRecipes > 0;

    if (!orderHasAnyRecipe) {
      return <Alert variant='warning'>
              {strings.NoneRecipeLinked}
            </Alert>;
    }

    return [
      ...recipeCards,
      ...linkingRequestCards
    ];
  }, [recipeCards, linkingRequestCards]);

  return (
    <>
      {body}
    </>
  );
}

export { TabRecipeLinking };